import { makeAutoObservable } from "mobx";
import { DELIVERY_ADDRESS_EMPTY_EXTRA } from "./ApartmentInfo";
import { Availability } from "../Availability";
export class DefaultApartmentInfo {
    constructor() {
        this.type = "Default";
        this.data = {
            floor: DELIVERY_ADDRESS_EMPTY_EXTRA.floor,
            aptNumber: DELIVERY_ADDRESS_EMPTY_EXTRA.aptNumber,
        };
        makeAutoObservable(this);
    }
    setData(updated) {
        this.data = { ...this.data, ...updated };
    }
    get availability() {
        return Availability.available();
    }
    get checkoutData() {
        return {
            ...DELIVERY_ADDRESS_EMPTY_EXTRA,
            ...this.data,
        };
    }
}
